export enum ActionTypes {
    LOGIN = "LOGIN",
    CLEAR_STATE = "CLEAR_STATE",
    UPDATE_USER = "UPDATE_USER",
    CHANGE_LANGUAGE = 'CHANGE_LANGUAGE',
}